function scrollToTop(element) {
  const modal = document.querySelector(element);
  modal && modal.scrollIntoView({ block: 'start', behavior: 'smooth' });
}

function findScrollableParent(node: Node | null): null | Element {
  if (node == null) {
    return null;
  }
  const { scrollHeight, parentNode, clientHeight } = node as Element;
  if (scrollHeight > clientHeight) {
    return node as Element;
  } else {
    return findScrollableParent(parentNode);
  }
}

export { findScrollableParent, scrollToTop };
